import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export const useDeleteOrganizationUser = () => {
  const queryClient = useQueryClient();

  const deleteUser = async (userId: number) => {
    const response = await Axios.delete(
      DELETE_URL(userId.toString()).deleteOrganizationUser
    );
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, number>(
    (userId: number) => deleteUser(userId),
    {
      onSuccess: (_, userId) => {
        queryClient.invalidateQueries(['users']);
        queryClient.invalidateQueries(['users', userId]);
      },
      useErrorBoundary: false
    }
  );
};
